import React from 'react'

import FocusableCard from './FocusableCard'

import type { CardProps } from './types'
import type { Empty } from '../../reducers/types/reducerTypes'

export function EmptyCard({ data, index, onFocus, layout }: CardProps<Empty>) {
  return (
    <FocusableCard<Empty>
      index={index}
      onFocus={onFocus}
      layout={layout}
      ttsText={data.title}
    >
      <p className="empty-card">{data.title}</p>
    </FocusableCard>
  )
}
